<template>
  <div class="shop-details">
    <header class="shop-info">
      <div class="shop-info_title">{{ cabinet.shopname }}</div>
      <p class="shop-info_desc">
        <img
          class="desc_ic"
          src="@/assets/imgs/shop/icon_shop_return.png"
          alt="shop_return"
        />
        {{ i18n.shop_desc_text }}
      </p>
    </header>
    <!-- <div class="available_rental">
      <div class="available_rental_title">{{ i18n.available_rental }}</div>
      <div class="available_rental_row">
        <p>rechargeable battery: {{ cabinet.rechargeablePowerBank }}</p>
        <p>fast-charging battery: {{ cabinet.fastChargePowerBank }}</p>
      </div>
    </div> -->
    <main class="shop_price">
      <ul class="shop_price_table">
        <li class="price_li">
          <p>Rental period</p>
          <p>Usage Fee</p>
        </li>
        <li
          class="price_li"
          :key="item.pId"
          v-for="item in priceStrategy.priceStrategyDetail"
        >
          <p>
            {{ item.pStartMinute + " - " + item.pEndMinute }}
            {{ " " + $t("order_item.min") }}
          </p>
          <p>{{ item.pSetcionFee + " " + cabinet.currencyName }}</p>
        </li>
      </ul>
      <div class="shop_point_type">
        <template v-for="list in point_list">
          <div v-if="list.show" class="shop_point_type_cloumn" :key="list.name">
            <span class="type_name">{{ list.name }}</span>
            <img class="type_icon" :src="list.icon" alt="type_icon" />
          </div>
        </template>
      </div>
      <div class="shop_rent_type">
        {{ rent_type == 2 ? "Fast Charge Power Bank" : "Standard Power Bank" }}
      </div>
    </main>
    <div class="shop_select">
      <p class="shop_select_title">Please select the type of battery.</p>
      <div class="shop_select_row">
        <button
          class="btn_rent_type btn"
          :class="rent_type == 1 ? 'act' : ''"
          @click="setRentType(1)"
        >
          Standard Power Bank
        </button>
        <button
          v-if="cabinet.fastChargePowerBankAvailable"
          class="btn_rent_type btn"
          :class="rent_type == 2 ? 'act' : ''"
          @click="setRentType(2)"
        >
          Fast Charge Power Bank
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    cabinet: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapState(["browser", "system"]),
    i18n() {
      return this.$t("home");
    },
    i18nMsg() {
      return this.$t("msg");
    },
    priceStrategy() {
      return this.cabinet && this.cabinet.priceStrategy;
    }
  },
  data() {
    return {
      rent_type: 1, // 1: standard, 2: fast charge
      point_list: [
        {
          show: true,
          name: "Type-C",
          icon: require("@/assets/imgs/shop/icon_typec.png")
        },
        {
          show: true,
          name: "Lightning",
          icon: require("@/assets/imgs/shop/icon_lightning.png")
        },
        {
          show: true,
          name: "Micro USB",
          icon: require("@/assets/imgs/shop/icon_micro_usb.png")
        }
      ]
    };
  },
  methods: {
    setRentType(type) {
      this.rent_type = type;
      this.$set(this.point_list[2], "show", type !== 2);
      this.$emit("onRentType", type);
    }
  },
  mounted() {
    if (this.cabinet && this.cabinet.defaultRentalProductType) {
      this.rent_type = this.cabinet.defaultRentalProductType;
    }
  }
};
</script>

<style lang="less" scoped>
.shop-details {
  position: relative;
  padding: 20px 36px;
}
.shop-info {
  padding: 36px;
  border-radius: 12px;
  background-color: #212121;
  color: #fff;
  &_title {
    font-size: 36px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2; /* 限制为两行 */
    overflow: hidden;
    text-overflow: ellipsis;
  }
  &_desc {
    font-size: 24px;
    margin: 6px 0 0;
    .desc_ic {
      width: 32px;
      height: 32px;
    }
  }
}
.available_rental {
  position: relative;
  margin: 24px 0;
  color: #fff;
  &_title {
    font-style: 28px;
    &::before {
      content: " ";
      display: inline-block;
      width: 12px;
      height: 32px;
      margin-right: 12px;
      vertical-align: middle;
      background-color: #fff;
    }
  }
  &_row {
    display: flex;
    justify-content: space-between;
  }
}
.shop_point_type {
  margin: 24px 0 52px;
  display: flex;
  justify-content: space-around;
  &_cloumn {
    display: flex;
    flex-flow: column;
    align-items: center;
    border-bottom: 1px solid #444;
    .type_name {
      font-size: 28px;
      color: #fff;
    }
    .type_icon {
      width: 92px;
      margin-top: 12px;
    }
  }
}
.shop_price {
  position: relative;
  margin-top: 32px;
  padding: 36px 36px 92px;
  border-radius: 12px;
  background-color: #212121;
  .shop_price_table {
    margin: 0 24px;
    max-height: 320px;
    overflow-y: auto;
    .price_li {
      display: flex;
      justify-content: space-between;
      color: #fff;
      font-size: 26px;
    }
  }
  .shop_rent_type {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 92px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 0 0 12px 12px;
    background-color: #fff;
    font-size: 28px;
  }
}

.shop_select {
  margin-top: 40px;
  &_title {
    font-size: 32px;
    color: #fff;
    text-align: center;
    margin-bottom: 20px;
  }
  .shop_select_row {
    display: flex;
    justify-content: space-between;
    .btn_rent_type {
      width: 48%;
      height: 112px;
      border-radius: 64px;
      padding: 0 32px;
      font-size: 28px;
      color: #616161;
      background-color: #3d3d3d;
      box-shadow: 4px 4 11px 2px rgba(65, 155, 164, 0.28);
      &.act {
        color: #000;
        background-color: #fff;
      }
    }
  }
}
</style>
